import React from 'react'
import { observer } from 'mobx-react-lite'
import { Row, Col } from '@evertel/web/ui'
import { UserTile } from '@evertel/web/user'
import { ACLRoomTile } from './ACLRoomTile'
import { DocumentACLsController } from '@evertel/document'
import { ACLButtonProps, ACLButton } from './ACLButton'

type ACLProps = ACLButtonProps

export const ACL: React.FC<ACLProps> = observer(({
    attachId,
    acl,
    documentACLController,
    onChangeACL
}) => {

    // handles missing acl but also filters out current department ACL which isnt used yet
    if (!acl?.id) return null

    const canEditACL = documentACLController.canEditACL(acl.id)

    const renderTile = () => {
        if (!acl || !acl.id) {
            console.log('ERROR: <DocumentShareModal> <Name/> missing acl prop')
            return null
        }

        if (acl.principalType === DocumentACLsController.principalTypes.Room) {
            // ROOM
            return (
                <ACLRoomTile
                    roomId={acl.principalId}
                    showMembersCount={true}
                />
            )
        } else if (acl.principalType === DocumentACLsController.principalTypes.BlueUser) {
            // USER
            return (
                <UserTile
                    userId={acl.principalId}
                    imageWidth={25}
                />
            )
        } else {
            return null
        }
    }

    return (
        <Row className="my-2">
            <Col xs={8}>
                {renderTile()}
            </Col>
            <Col
                xs={4}
                align="right">
                <ACLButton
                    attachId={attachId}
                    acl={acl}
                    documentACLController={documentACLController}
                    onChangeACL={onChangeACL}
                    disabled={!canEditACL}
                />
            </Col>
        </Row>
    )
})
